import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { initializeApp, getApps } from 'firebase/app';
import { environment } from '../../environments/environment';
import { getAuth } from 'firebase/auth';

@Injectable()
export class RequestHeaderInterceptor implements HttpInterceptor {
    constructor() {
        // Initialize Firebase app only once
        if (!getApps().length) {
            initializeApp(environment.firebase);
        }
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        try {
            const auth = getAuth();
            const currentUser = auth.currentUser;

            // Skip adding token for assets or if no user is logged in
            if (!currentUser || request.url.includes('assets')) {
                return next.handle(request).pipe(
                    catchError((error: HttpErrorResponse) => this.handleAuthError(error))
                );
            }


            return from(currentUser.getIdToken()).pipe(
                switchMap((token) => {
                    console.log("tokennnnnn")
                    const clonedRequest = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    return next.handle(clonedRequest).pipe(
                        catchError((error: HttpErrorResponse) => this.handleAuthError(error))
                    );
                })
            );
        } catch (error) {
            console.error('Interceptor error:', error);
            return next.handle(request);
        }
    }

    private handleAuthError(error: HttpErrorResponse): Observable<never> {
        if (error.status === 401) {
        }
        return throwError(() => error);
    }
}
